var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-grid__item m-grid__item--fluid m-wrapper",staticStyle:{"overflow":"auto"},attrs:{"id":"iframeContent"}},[_c('div',{staticClass:"m-content",staticStyle:{"overflow":"visible"},attrs:{"id":"divContent"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }